import { render } from "./Index.vue?vue&type=template&id=5038ba60&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=5038ba60&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-meter-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5038ba60"],['__file',"src/assets/js/pages/MeterConfig/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5038ba60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5038ba60', __exports__)) {
    api.reload('5038ba60', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=5038ba60&scoped=true", () => {
    api.rerender('5038ba60', render)
  })

}


export default __exports__